"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currencyConfig = void 0;
exports.currencyFormatter = currencyFormatter;
exports.numberFormatter = numberFormatter;
var _Core = _interopRequireDefault(require("../dragon/store/Core"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Use to override locale used for money to string, prevent SEK when using en_GB etc.
 */
var currencyConfig = exports.currencyConfig = {
  SCC: {
    skipIntl: true,
    sign: " SC",
    behind: true,
    hideInBitmap: true
  },
  GCC: {
    skipIntl: true,
    sign: " GC",
    behind: true,
    hideInBitmap: true
  },
  USD: {
    locale: "en_US",
    sign: "$"
  },
  CAD: {
    locale: "en_CA"
  },
  EUR: {
    locale: "en_GB",
    sign: "€"
  },
  // special none breaking spaces here
  SEK: {
    locale: "sv_SE",
    sign: String.fromCharCode(160) + "kr",
    behind: true,
    thousandDelimiter: String.fromCharCode(160),
    decimalDelimiter: ","
  },
  DKK: {
    locale: "da_DK",
    sign: String.fromCharCode(160) + "kr",
    behind: true,
    thousandDelimiter: String.fromCharCode(160)
    // dd: ",",
  },
  NOK: {
    locale: "nb_NO",
    sign: String.fromCharCode(160) + "kr",
    behind: true,
    thousandDelimiter: String.fromCharCode(160)
    // dd: ",",
  },
  CHF: {
    // NO CURRENCY SIGN according to wiki?
    //locale: "de_CH",
    skipIntl: true,
    // l: "en_GB",
    sign: "Fr." + String.fromCharCode(160),
    //  sd: String.fromCharCode(160),
    //   dd: ",",
    decimalDelimiter: ".",
    thousandDelimiter: "’",
    hideInBitmap: true
  },
  CNY: {
    locale: "zh_CH",
    sign: "¥"
  },
  RMB: {
    locale: "zh_CH",
    sign: "¥"
  },
  JPY: {
    locale: "ja_JP",
    sign: "¥",
    fractions: 0
  },
  ARS: {
    locale: "es_AR",
    sign: "$",
    fractions: 0
  },
  ARX: {
    locale: "es_AR",
    sign: "$",
    fractions: 0,
    currencyCode: "ARS"
  },
  CLP: {
    locale: "es_CL",
    sign: "$"
  },
  COP: {
    locale: "es_CO",
    sign: "$"
  },
  MXN: {
    locale: "es_MX",
    sign: "$"
  },
  UYU: {
    locale: "es_UY",
    sign: "$"
  },
  JMD: {
    locale: "en_JM",
    sign: "$"
  },
  IDR: {
    locale: "id_ID",
    sign: "Rp",
    fractions: 0
  },
  THB: {
    locale: "th_TH",
    sign: "฿",
    hideInBitmap: true
  },
  RUB: {
    locale: "ru_RU",
    sign: "₽"
  },
  VND: {
    sign: "₫",
    fractions: 0
  },
  PHP: {
    sign: "₱"
  },
  TRY: {
    locale: "tr_TR",
    sign: "₺"
  },
  HKD: {
    // we run same us as USD, don't want HK$ to big
    skipIntl: true,
    sign: "$"
  },
  PLN: {
    locale: "pl_PL",
    sign: "zł"
  },
  NZD: {
    // we run same us as USD, don't want NZ$ to big
    locale: "en_NZ",
    sign: "$"
  },
  SGD: {
    locale: "en_SG",
    sign: "S$"
  },
  TWD: {
    locale: "zh_TW",
    sign: "$"
  },
  ZAR: {
    locale: "en_ZA",
    sign: "R"
  },
  CZK: {
    locale: "cs_CZ",
    sign: "Kč"
  },
  AED: {
    locale: "ar_AE",
    sign: ""
  },
  HUF: {
    //Issue with Ft (missing small t in many games) BITMAP ISSUE
    //locale: "de_CH",
    skipIntl: true,
    // l: "en_GB",
    sign: String.fromCharCode(160) + "Ft",
    //  sd: String.fromCharCode(160),
    //   dd: ",",
    behind: true,
    decimalDelimiter: ".",
    thousandDelimiter: String.fromCharCode(160),
    hideInBitmap: true,
    fractions: 0 // no fractions
  },
  UZS: {
    //  crypto: true, // Not crypto but we use same f ormat as cryptos.
    //skipIntl: true,
    fractions: 0
    // sign: " "
  },
  IRR: {
    // correct, should be , for grouping and no fractions.

    fractions: 0,
    sign: " "
  },
  MNT: {
    fractions: 0,
    sign: " " // ₮ is the correct sign, we don't have this in any fonts
  },
  AOA: {
    skipIntl: true,
    fractions: 0,
    sign: "Kz " // 
  },
  BWP: {
    skipIntl: true,
    fractions: 2,
    sign: "P" // 
  },
  CDF: {
    skipIntl: true,
    fractions: 0,
    sign: "FC" + String.fromCharCode(160)
  },
  GNF: {
    skipIntl: true,
    fractions: 0,
    sign: "FG" + String.fromCharCode(160)
  },
  GTQ: {
    skipIntl: true,
    fractions: 2,
    sign: "Q",
    decimalDelimiter: ",",
    thousandDelimiter: "."
  },
  JOD: {
    skipIntl: true,
    fractions: 2,
    sign: " "
    //  decimalDelimiter: ".",
    //  spaceDelimiter: ","
  },
  KWD: {
    //  skipIntl: true,
    //fractions: 2, // should be 3 but we use 2 to match other currencies.
  },
  LSL: {
    skipIntl: true,
    fractions: 2,
    // should be 3 but we use 2 to match other currencies.
    sign: "M"
  },
  LYD: {
    //  skipIntl: true,
    //fractions: 2, // should be 3 but we use 2 to match other currencies.
    sign: " ",
    skipIntl: true
  },
  MAD: {
    skipIntl: true,
    //  skipIntl: true,
    //fractions: 2, // should be 3 but we use 2 to match other currencies.
    sign: " ",
    //  crypto: true, // Not crypto but we use same format as cryptos.
    decimalDelimiter: ".",
    thousandDelimiter: ","
  },
  MKD: {
    skipIntl: true,
    //  skipIntl: true,
    //fractions: 2, // should be 3 but we use 2 to match other currencies.
    sign: " ",
    //  crypto: true, // Not crypto but we use same format as cryptos.
    decimalDelimiter: ".",
    thousandDelimiter: ","
  },
  // CRYPTOS. ALL SHOULD BE USD FORMAT
  BTC: {
    sign: "₿",
    currencyCode: "USD",
    skipIntl: true,
    hideInBitmap: true
  },
  MBT: {
    skipIntl: true,
    sign: "m₿",
    fractions: 2,
    hideInBitmap: true
  },
  mBT: {
    skipIntl: true,
    sign: "m₿",
    fractions: 3,
    hideInBitmap: true
  },
  UBT: {
    sign: "u₿",
    skipIntl: true,
    hideInBitmap: true
  },
  ETH: {
    sign: "Ξ",
    skipIntl: true,
    hideInBitmap: true
  },
  MTH: {
    sign: "mΞ",
    skipIntl: true,
    hideInBitmap: true
  },
  UTH: {
    sign: "uΞ",
    skipIntl: true,
    hideInBitmap: true
  },
  LTC: {
    skipIntl: true,
    sign: "Ł",
    hideInBitmap: true
  },
  MTC: {
    skipIntl: true,
    sign: "mŁ",
    hideInBitmap: true
  },
  UTC: {
    skipIntl: true,
    sign: "uŁ",
    hideInBitmap: true
  },
  TET: {
    skipIntl: true,
    sign: "T",
    hideInBitmap: true
  }
};

/*let noFractionCurrencies = [
  "IDR",
  "VND"
]*/

var formatterNumber;
var formatterNumberNoDecimals;
/**
 * 
 * @param value Value to be formatted
 * @param currency the currency
 * @param locale formatted according to this locale
 * @param fractions how many fractions.
 * @param ui if this is a ui show. This will by pass the showIngameCurrency config, used for reduced currency showings.
 * @returns 
 */
function numberFormatter(value, currency, locale, fractions, ui) {
  var config = _Core["default"].getState().config;
  if (config.hideCurrencySign || !ui && config.noInGameCurrencySign) {
    return formatNumberHard(value);
  }

  // Play with Coins Support
  if (config.playWithCoins) return Math.trunc(value).toString();
  if (!locale) {
    locale = config.locale;
  }
  if (Intl && Intl.NumberFormat) {
    var _currencyConfig$curre;
    // we ignored fractions passed if currency has set 0 fractions or is a no fraction currency.
    if (fractions === 0 || ((_currencyConfig$curre = currencyConfig[currency]) === null || _currencyConfig$curre === void 0 ? void 0 : _currencyConfig$curre.fractions) == 0) {
      if (formatterNumberNoDecimals == undefined) {
        var _currencyConfig$curre2, _currencyConfig$curre3, _currencyConfig$curre4;
        // note purpose of this is uniform. For example euro is is usually 1.000,00 in most countries but most provider to USD/GBP 1,000.00
        if ((_currencyConfig$curre2 = currencyConfig[currency]) !== null && _currencyConfig$curre2 !== void 0 && _currencyConfig$curre2.locale) locale = currencyConfig[currency].locale;
        if (((_currencyConfig$curre3 = currencyConfig[currency]) === null || _currencyConfig$curre3 === void 0 ? void 0 : _currencyConfig$curre3.fractions) != null && fractions == null) fractions = (_currencyConfig$curre4 = currencyConfig[currency]) === null || _currencyConfig$curre4 === void 0 ? void 0 : _currencyConfig$curre4.fractions;
        locale = locale.replace("_", "-");
        formatterNumberNoDecimals = new Intl.NumberFormat(locale, {
          minimumFractionDigits: 0
          // the default value for minimumFractionDigits depends on the currency
          // and is usually already 2
        });
      }
      return formatterNumberNoDecimals.format(value);
    } else {
      if (formatterNumber == undefined) {
        var _currencyConfig$curre5, _currencyConfig$curre6, _currencyConfig$curre7;
        // note purpose of this is uniform. For example euro is is usually 1.000,00 in most countries but most provider to USD/GBP 1,000.00
        if ((_currencyConfig$curre5 = currencyConfig[currency]) !== null && _currencyConfig$curre5 !== void 0 && _currencyConfig$curre5.locale) locale = currencyConfig[currency].locale;
        if (((_currencyConfig$curre6 = currencyConfig[currency]) === null || _currencyConfig$curre6 === void 0 ? void 0 : _currencyConfig$curre6.fractions) != null && fractions == null) fractions = (_currencyConfig$curre7 = currencyConfig[currency]) === null || _currencyConfig$curre7 === void 0 ? void 0 : _currencyConfig$curre7.fractions;
        locale = locale.replace("_", "-");
        formatterNumber = new Intl.NumberFormat(locale, {
          minimumFractionDigits: fractions != null ? fractions : 2
          // the default value for minimumFractionDigits depends on the currency
          // and is usually already 2
        });
      }
      return formatterNumber.format(value);
    }
  } else {
    return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  }
}
var formatter;
/**
 * 
 * @param value Value to be formatted
 * @param currency the currency
 * @param locale formatted according to this locale
 * @param fractions how many fractions.
 * @param ui if this is a ui show. This will by pass the showIngameCurrency config, used for reduced currency showings.
 * @param bitMap if this is a bitmap show. This will by pass the hideInBitmap config, used for reduced currency showings.
 * @param allowThreeLetters if this should allow three letter currency code
 * @returns 
 */
function currencyFormatter(value, currency, locale, fractions, ui, bitMap, allowThreeLetters) {
  var _currencyConfig$curre8, _currencyConfig$curre9, _currencyConfig$curre10, _currencyConfig$curre11;
  var config = _Core["default"].getState().config;
  // added so it does NOT default to USD if currency is undefined, this is really a hack.
  if (config.hideCurrencySign || !ui && config.noInGameCurrencySign || currency === undefined) return formatNumberHard(value);

  // Play with Coins Support
  if (config.playWithCoins) return Math.trunc(value).toString();

  // If value should be truncated, used by VND and ultra inflated currency's.
  var truncation = config.currencyTruncation;
  if (truncation && truncation > 0) {
    value = value / truncation;
  }
  // RMB to CNY due to different name, not actually the same but for us it is.
  if (currency == "RMB") currency = "CNY";

  // get locale from state if not present in the call. can vary.
  if (!locale) {
    locale = config.locale;
  }

  // currency specific fractions settings.
  if (((_currencyConfig$curre8 = currencyConfig[currency]) === null || _currencyConfig$curre8 === void 0 ? void 0 : _currencyConfig$curre8.fractions) != undefined && fractions == undefined) fractions = (_currencyConfig$curre9 = (_currencyConfig$curre10 = currencyConfig[currency]) === null || _currencyConfig$curre10 === void 0 ? void 0 : _currencyConfig$curre10.fractions) !== null && _currencyConfig$curre9 !== void 0 ? _currencyConfig$curre9 : 2; // default to 2 if not set.
  if (fractions == undefined) fractions = 2; // default to 2 if not set.

  // If fractions are set to lower than the amount, yet the value has decimals, we should use the decimals from the value.
  // if (value.dragonCountDecimals() > fractions) // This does not work when INTL is used.
  //    fractions = value.dragonCountDecimals();  This is a very bad idea!

  // standard, for most currencies when INTL is available.
  if (Intl && Intl.NumberFormat && currency && currency != "XXX" && !((_currencyConfig$curre11 = currencyConfig[currency]) !== null && _currencyConfig$curre11 !== void 0 && _currencyConfig$curre11.skipIntl)) {
    var _currencyConfig$curre12;
    if (bitMap && (_currencyConfig$curre12 = currencyConfig[currency]) !== null && _currencyConfig$curre12 !== void 0 && _currencyConfig$curre12.hideInBitmap) {
      return numberFormatter(value, currency, locale, fractions, ui);
    }
    if (!formatter) {
      var _currencyConfig$curre13, _currencyConfig$curre14;
      if ((_currencyConfig$curre13 = currencyConfig[currency]) !== null && _currencyConfig$curre13 !== void 0 && _currencyConfig$curre13.locale) locale = currencyConfig[currency].locale;
      locale = locale.replace("_", "-");
      formatter = new Intl.NumberFormat(locale, {
        style: "currency",
        // currencyDisplay: 'symbol', //causing safari 14 issue ???
        currency: (_currencyConfig$curre14 = currencyConfig[currency]) !== null && _currencyConfig$curre14 !== void 0 && _currencyConfig$curre14.currencyCode ? currencyConfig[currency].currencyCode : currency,
        minimumFractionDigits: fractions != null ? fractions : 2,
        maximumFractionDigits: fractions != null ? fractions : 2
        // the default value for minimumFractionDigits depends on the currency
        // and is usually already 2
      });
    }
    if (allowThreeLetters) return formatter.format(value);else return formatter.format(value).replace(/\b[A-Z]{3}\b/g, "").trim();
  }
  // Practice.
  else if (currency == "XXX") {
    return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  }
  // when INTL is NOT available. fallback. 
  else {
    var cfg = currencyConfig[currency];
    var sign = "$";
    if (cfg !== null && cfg !== void 0 && cfg.sign) sign = currencyConfig[currency].sign;
    if (bitMap && cfg !== null && cfg !== void 0 && cfg.hideInBitmap) sign = "";
    if (cfg !== null && cfg !== void 0 && cfg.behind) {
      return value.dragonFallbackFormat(fractions != null ? fractions : 2, 3, cfg === null || cfg === void 0 ? void 0 : cfg.thousandDelimiter, cfg === null || cfg === void 0 ? void 0 : cfg.decimalDelimiter) + sign;
    } else {
      return sign + value.dragonFallbackFormat(fractions != null ? fractions : 2, 3, cfg === null || cfg === void 0 ? void 0 : cfg.thousandDelimiter, cfg === null || cfg === void 0 ? void 0 : cfg.decimalDelimiter);
    }
  }
}
Number.prototype.dragonFallbackFormat = function (n, x, s, c) {
  var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")",
    num = this.toFixed(Math.max(0, ~~n));
  return (c ? num.replace(".", c) : num).replace(new RegExp(re, "g"), "$&" + (s || ","));
};
Number.prototype.dragonCountDecimals = function () {
  if (Math.floor(this.valueOf()) === this.valueOf()) return 0;
  return this.toString().split(".")[1].length || 0;
};

/**
 * 
 * Hard version
 * 
 * @param number 
 * @returns 
 */
function formatNumberHard(number) {
  number = number.toFixed(2) + '';
  var x = number.split('.');
  var x1 = x[0];
  var x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}
//# sourceMappingURL=currencyFormatter.js.map